export default __webpack_public_path__ + "static/media/eye-purple.529c3fe7.svg";